import React, { useContext } from 'react';
import SideMenu, { SideMenuLink } from '@amzn/meridian/side-menu';
import { FormattedMessage } from 'react-intl';
import {
  SideMenuControllerProps,
  RELATION_TO_USER,
  SIDE_MENU_PATH,
} from '../../Types/types';
import { StateContext } from '../../../../../GlobalStateStore';

const CustomziedSideMenu: React.FC<SideMenuControllerProps> = ({
  teamProfile,
  hash,
  setHash,
  openLinkHash,
  setOpenLinkHash,
  expanded,
  setExpanded,
  setFocusProfile,
}: SideMenuControllerProps): React.ReactElement => {
  const globalState = useContext(StateContext);
  const { inspireOptions } = globalState.state;
  const { isTm, isOm, requesterUserID, requesterUsername } =
    inspireOptions.data;

  const allTMsCount = teamProfile.reportingTeam.filter(
    profile => profile.isManager
  ).length;
  const allAssociatesCount = teamProfile.reportingTeam.filter(
    profile => !profile.isManager
  ).length;
  const directAssociatesCount = teamProfile.reportingTeam.filter(
    profile =>
      profile.relatedUser.relationToUser === RELATION_TO_USER.DIRECT_REPORT
  ).length;
  const sharedProfileCount = teamProfile.reportingTeam.filter(
    profile => profile.relatedUser.relationToUser === RELATION_TO_USER.COACHEE
  ).length;

  return (
    <SideMenu>
      {isOm && (
        <SideMenuLink
          key={SIDE_MENU_PATH.ALL_TMS}
          href={SIDE_MENU_PATH.ALL_TMS}
          selected={hash === SIDE_MENU_PATH.ALL_TMS}
          open={openLinkHash === SIDE_MENU_PATH.ALL_TMS}
          data-csa-c-type='link'
          data-csa-c-slot-id='arc-mainview-side-menu-slot'
          data-csa-c-tag1='Team'
          data-csa-c-tag2='Tms'
          data-csa-c-profile-id={requesterUserID}
          data-csa-c-username={requesterUsername}
          data-csa-c-is-tm={isTm}
          data-csa-c-content-id={SIDE_MENU_PATH.ALL_TMS}
          onClick={hash => {
            setHash(hash);
            setOpenLinkHash(
              openLinkHash === SIDE_MENU_PATH.ALL_TMS ? null : hash
            );
            if (expanded) {
              setExpanded(false);
              setFocusProfile(null);
            }
          }}
          data-cy='all-associates'
        >
          <FormattedMessage
            id='cs_perfportal_arc_all_tms_heading'
            defaultMessage='All TMs'
          />{' '}
          {`(${allTMsCount})`}
          {teamProfile.reportingTeam
            .filter(profile => profile.isManager)
            .map(profile => {
              return (
                <SideMenuLink
                  key={`#all_${profile.relatedUser.alias}`}
                  href={`#all_${profile.relatedUser.alias}`}
                  selected={hash === `#all_${profile.relatedUser.alias}`}
                  data-csa-c-type='link'
                  data-csa-c-slot-id='arc-mainview-side-menu-slot'
                  data-csa-c-tag1='Team'
                  data-csa-c-tag2='Associates'
                  data-csa-c-profile-id={requesterUserID}
                  data-csa-c-username={requesterUsername}
                  data-csa-c-is-tm={isTm}
                  data-csa-c-content-id={`#all_${profile.relatedUser.alias}`}
                  onClick={hash => {
                    setHash(hash);
                    setExpanded(true);
                    setFocusProfile(profile);
                  }}
                  onEscape={() => {
                    setExpanded(false);
                    setFocusProfile(null);
                    setHash(SIDE_MENU_PATH.ALL_TMS);
                    setOpenLinkHash(null);
                  }}
                  data-cy={`all_${profile.relatedUser.alias}`}
                >
                  {profile.relatedUser.displayName}
                </SideMenuLink>
              );
            })}
        </SideMenuLink>
      )}
      {allAssociatesCount > 0 && (
        <SideMenuLink
          key={SIDE_MENU_PATH.ALL_ASSOCIATES}
          href={SIDE_MENU_PATH.ALL_ASSOCIATES}
          selected={hash === SIDE_MENU_PATH.ALL_ASSOCIATES}
          open={openLinkHash === SIDE_MENU_PATH.ALL_ASSOCIATES}
          data-csa-c-type='link'
          data-csa-c-slot-id='arc-mainview-side-menu-slot'
          data-csa-c-tag1='Team'
          data-csa-c-tag2='Associates'
          data-csa-c-profile-id={requesterUserID}
          data-csa-c-username={requesterUsername}
          data-csa-c-is-tm={isTm}
          data-csa-c-content-id={SIDE_MENU_PATH.ALL_ASSOCIATES}
          onClick={hash => {
            setHash(hash);
            setOpenLinkHash(
              openLinkHash === SIDE_MENU_PATH.ALL_ASSOCIATES ? null : hash
            );
            if (expanded) {
              setExpanded(false);
              setFocusProfile(null);
            }
          }}
          data-cy='all-associates'
        >
          <FormattedMessage
            id='cs_perfportal_arc_all_associates_heading'
            defaultMessage='All Associates'
          />{' '}
          {`(${allAssociatesCount})`}
          {teamProfile.reportingTeam
            .filter(profile => !profile.isManager)
            .map(profile => {
              return (
                <SideMenuLink
                  key={`#all_${profile.relatedUser.alias}`}
                  href={`#all_${profile.relatedUser.alias}`}
                  selected={hash === `#all_${profile.relatedUser.alias}`}
                  data-csa-c-type='link'
                  data-csa-c-slot-id='arc-mainview-side-menu-slot'
                  data-csa-c-tag1='Team'
                  data-csa-c-tag2='Associates'
                  data-csa-c-profile-id={requesterUserID}
                  data-csa-c-username={requesterUsername}
                  data-csa-c-is-tm={isTm}
                  data-csa-c-content-id={`#all_${profile.relatedUser.alias}`}
                  onClick={hash => {
                    setHash(hash);
                    setExpanded(true);
                    setFocusProfile(profile);
                  }}
                  onEscape={() => {
                    setExpanded(false);
                    setFocusProfile(null);
                    setHash(SIDE_MENU_PATH.ALL_ASSOCIATES);
                    setOpenLinkHash(null);
                  }}
                  data-cy={`all_${profile.relatedUser.alias}`}
                >
                  {profile.relatedUser.displayName}
                </SideMenuLink>
              );
            })}
        </SideMenuLink>
      )}
      {!isOm && (
        <SideMenuLink
          key={SIDE_MENU_PATH.DIRECT_REPORT}
          href={SIDE_MENU_PATH.DIRECT_REPORT}
          selected={hash === SIDE_MENU_PATH.DIRECT_REPORT}
          open={openLinkHash === SIDE_MENU_PATH.DIRECT_REPORT}
          data-csa-c-type='link'
          data-csa-c-slot-id='arc-mainview-side-menu-slot'
          data-csa-c-tag1='Team'
          data-csa-c-tag2='Associates'
          data-csa-c-profile-id={requesterUserID}
          data-csa-c-username={requesterUsername}
          data-csa-c-is-tm={isTm}
          data-csa-c-content-id={`#direct`}
          onClick={hash => {
            setHash(hash);
            setOpenLinkHash(
              openLinkHash === SIDE_MENU_PATH.DIRECT_REPORT ? null : hash
            );
            if (expanded) {
              setExpanded(false);
              setFocusProfile(null);
            }
          }}
          data-cy='direct-reports'
        >
          <FormattedMessage
            id='cs_perfportal_arc_direct_reports_heading'
            defaultMessage='Direct Reports'
          />{' '}
          {`(${directAssociatesCount})`}
          {teamProfile.reportingTeam
            .filter(
              profile =>
                profile.relatedUser.relationToUser ===
                RELATION_TO_USER.DIRECT_REPORT
            )
            .map(profile => {
              return (
                <SideMenuLink
                  key={`#direct_${profile.relatedUser.alias}`}
                  href={`#direct_${profile.relatedUser.alias}`}
                  selected={hash === `#direct_${profile.relatedUser.alias}`}
                  data-csa-c-type='link'
                  data-csa-c-slot-id='arc-mainview-side-menu-slot'
                  data-csa-c-tag1='Team'
                  data-csa-c-tag2='Associates'
                  data-csa-c-profile-id={requesterUserID}
                  data-csa-c-username={requesterUsername}
                  data-csa-c-is-tm={isTm}
                  data-csa-c-content-id={`#direct_${profile.relatedUser.alias}`}
                  onClick={() => {
                    setHash(`#direct_${profile.relatedUser.alias}`);
                    setExpanded(true);
                    setFocusProfile(profile);
                  }}
                  onEscape={() => {
                    setHash(SIDE_MENU_PATH.DIRECT_REPORT);
                    setOpenLinkHash(null);
                    setExpanded(false);
                    setFocusProfile(null);
                  }}
                >
                  {profile.relatedUser.displayName}
                </SideMenuLink>
              );
            })}
        </SideMenuLink>
      )}
      {!isOm && (
        <SideMenuLink
          key={SIDE_MENU_PATH.SHARED_PROFILE}
          href={SIDE_MENU_PATH.SHARED_PROFILE}
          selected={hash === SIDE_MENU_PATH.SHARED_PROFILE}
          open={openLinkHash === SIDE_MENU_PATH.SHARED_PROFILE}
          data-csa-c-type='link'
          data-csa-c-slot-id='arc-mainview-side-menu-slot'
          data-csa-c-tag1='Team'
          data-csa-c-tag2='Associates'
          data-csa-c-profile-id={requesterUserID}
          data-csa-c-username={requesterUsername}
          data-csa-c-is-tm={isTm}
          data-csa-c-content-id={`#shared`}
          onClick={hash => {
            setHash(hash);
            setOpenLinkHash(
              openLinkHash === SIDE_MENU_PATH.SHARED_PROFILE ? null : hash
            );
            if (expanded) {
              setExpanded(false);
              setFocusProfile(null);
            }
          }}
          data-cy='shared'
        >
          <FormattedMessage
            id='cs_perfportal_arc_shared_profiles_heading'
            defaultMessage='Shared Profiles'
          />{' '}
          {`(${sharedProfileCount})`}
          {teamProfile.reportingTeam
            .filter(
              profile =>
                profile.relatedUser.relationToUser === RELATION_TO_USER.COACHEE
            )
            .map(profile => {
              return (
                <SideMenuLink
                  key={`#shared_${profile.relatedUser.alias}`}
                  href={`#shared_${profile.relatedUser.alias}`}
                  selected={hash === `#shared_${profile.relatedUser.alias}`}
                  data-csa-c-type='link'
                  data-csa-c-slot-id='arc-mainview-side-menu-slot'
                  data-csa-c-tag1='Team'
                  data-csa-c-tag2='Associates'
                  data-csa-c-profile-id={requesterUserID}
                  data-csa-c-username={requesterUsername}
                  data-csa-c-is-tm={isTm}
                  data-csa-c-content-id={`#shared_${profile.relatedUser.alias}`}
                  onClick={() => {
                    setHash(`#shared_${profile.relatedUser.alias}`);
                    setExpanded(true);
                    setFocusProfile(profile);
                  }}
                  onEscape={() => {
                    setHash(SIDE_MENU_PATH.SHARED_PROFILE);
                    setOpenLinkHash(null);
                    setExpanded(false);
                    setFocusProfile(null);
                  }}
                >
                  {profile.relatedUser.displayName}
                </SideMenuLink>
              );
            })}
        </SideMenuLink>
      )}
    </SideMenu>
  );
};

export default CustomziedSideMenu;
